export default __webpack_public_path__ + "static/hero_rentvisie-961c917336d030313c5f583d130daba0.webp";